import { render, staticRenderFns } from "./Classifieds.vue?vue&type=template&id=7939e870&"
import script from "./Classifieds.vue?vue&type=script&lang=js&"
export * from "./Classifieds.vue?vue&type=script&lang=js&"
import style0 from "./Classifieds.vue?vue&type=style&index=0&id=7939e870&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports